import { UserDto } from '@families-link/shared';
import { FC, useCallback, useMemo } from 'react';
import { CoreTableActionsCell, CellAction } from '../../../_core/components/_ui/core-table';
import { UsersTableHandlers } from './users-table.component';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { DeleteIcon, EditIcon, ShareIcon } from '../../../_core/components/icons';
import { useTranslation } from 'react-i18next';
export interface UsersTableActionsProps extends UsersTableHandlers {
	user: UserDto;
}

export const UsersTableActions: FC<UsersTableActionsProps> = (props) => {
	const { user, onEdit, onDelete, onMailSend, onResetPassword } = props;
	const [t] = useTranslation();
	const handleDeleteUser = useCallback(() => {
		if (!user) {
			return;
		}

		onDelete?.(user);
	}, [onDelete, user]);

	const handleEditUser = useCallback(() => {
		if (!user) {
			return;
		}

		onEdit?.(user);
	}, [onEdit, user]);

	const handleMailSend = useCallback(() => {
		if (!user) {
			return;
		}

		onMailSend?.(user);
	}, [onMailSend, user]);

	const handleResetPassword = useCallback(() => {
		if (!user) {
			return;
		}

		onResetPassword?.(user);
	}, [onResetPassword, user]);

	const actions = useMemo<CellAction[]>(
		() => [
			{
				id: 'edit',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.edit'),
				props: {
					children: <EditIcon sx={{ fontSize: 30 }} color="primary" />,
					onClick: handleEditUser,
					variant: 'secondary',
				},
			},
			{
				id: 'mail',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.send-invitaion'),
				props: {
					children: <ShareIcon sx={{ fontSize: 30 }} color="primary" />,
					onClick: handleMailSend,
					variant: 'secondary',
				},
			},
			{
				id: 'more',
				type: 'menu',
				props: {
					options: [
						{
							id: 'resetPassword',
							label: 'Reset password',
							icon: <RestartAltOutlinedIcon color="primary" />,
							onClick: handleResetPassword,
						},
						{
							id: 'delete',
							label: 'Delete',
							icon: <DeleteIcon color="primary" />,
							onClick: handleDeleteUser,
						},
					],
				},
			},
		],
		[handleEditUser, handleMailSend, handleResetPassword, handleDeleteUser]
	);

	return <CoreTableActionsCell actions={actions} />;
};
